import { Grid } from '@mui/material';

import { GDMGridComponent } from './GDMGrid.type';

/* TODO: Implement component using GDM default design */
const GDMGrid: GDMGridComponent = props => <Grid {...props} />;

export default GDMGrid;
